import React from 'react'
import Layout from '../components/Layout/index'
import Section from '../components/Section/index'
import SubHeader from '../components/SubHeader/index'
import ColumsGrid from '../components/ColumnsGrid/index'
import ContactPerson from '../components/ContactPerson/index'

import DanielPhoto from '../assets/images/Daniel-contact.jpeg'
import TuomasPhoto from '../assets/images/Tuomas Auvinen.jpeg'

const ContactPage = () => (
  <Layout>
    {
      <>
        <Section variant="header">
          <SubHeader heading="Yhteys" />
        </Section>
        <Section
          variant="description"
          description="Haluatko olla mukana tekemässä kampanjaa? Ole yhteydessä suoraan Danieliin tai Tuomakseen!"
        >
          <ColumsGrid>
            <ContactPerson
              colums={2}
              contactPersonImg={DanielPhoto}
              fullName="Daniel Rahman"
              title="Ehdokas"
              email="daniel@integrify.fi"
              phoneNumber="+358 50 565 0448"
            />
            <ContactPerson
              colums={2}
              contactPersonImg={TuomasPhoto}
              fullName="Tuomas Auvinen"
              title="Kampanjapäällikkö"
              email="tuomas.auvinen@me.com"
              phoneNumber="+358 40 738 0860"
            />
          </ColumsGrid>
        </Section>
      </>
    }
  </Layout>
)

export default ContactPage
